import { D, dec } from '@makila/fiscal';
/**
 * Retalho (proposta §3, gestor de loja): códigos de barras, etiquetas de
 * balança e preços por quantidade. Sem I/O — o terminal e a nuvem usam o mesmo.
 */
/** Dígito de controlo EAN/GTIN (módulo 10, pesos 3-1 a partir da direita). */
export function eanCheckDigit(body) {
    let sum = 0;
    for (let i = 0; i < body.length; i++)
        sum += Number(body[body.length - 1 - i]) * (i % 2 === 0 ? 3 : 1);
    return (10 - (sum % 10)) % 10;
}
/** EAN-13 ou EAN-8 com o dígito de controlo certo. */
export function isValidEan(code) {
    if (!/^(\d{8}|\d{13})$/.test(code))
        return false;
    return eanCheckDigit(code.slice(0, -1)) === Number(code.at(-1));
}
export function parseScaleBarcode(code, value) {
    if (!/^2\d{12}$/.test(code) || !isValidEan(code))
        return null;
    const plu = code.slice(2, 7);
    const v = new D(code.slice(7, 12));
    if (v.isZero())
        return null;
    return value === 'weight'
        ? { plu, weightKg: v.div(1000).toString(), price: null }
        : { plu, weightKg: null, price: v.div(100).toFixed(2) };
}
/**
 * Quantidade de uma etiqueta de balança. Com o peso embutido, é o peso. Com
 * o preço embutido, é o preço a dividir pelo preço por kg, a 3 casas (o grama):
 * o total da linha pode diferir do impresso na etiqueta em centavos — o talão e
 * a assinatura usam sempre o total calculado.
 */
export function scaleQuantity(scan, unitPrice) {
    if (scan.weightKg)
        return scan.weightKg;
    const p = dec(unitPrice);
    if (p.isZero())
        throw new Error('Artigo de balança sem preço');
    const q = new D(scan.price).div(p).toDecimalPlaces(3);
    return (q.isZero() ? new D('0.001') : q).toString();
}
export function checkPriceTiers(tiers) {
    const out = tiers.map((t) => ({ minQty: dec(t.minQty).toString(), unitPrice: dec(t.unitPrice).toString() }));
    for (const t of out) {
        if (new D(t.minQty).lessThanOrEqualTo(1))
            throw new Error('Preço por quantidade: a quantidade mínima tem de ser maior que 1');
        if (new D(t.unitPrice).isNegative())
            throw new Error('Preço por quantidade: preço inválido');
    }
    if (new Set(out.map((t) => t.minQty)).size !== out.length)
        throw new Error('Preço por quantidade: quantidades mínimas repetidas');
    return out.sort((a, b) => new D(a.minQty).comparedTo(b.minQty));
}
/** Preço unitário para a quantidade: o escalão mais alto que a quantidade atinge; senão, o preço base. */
export function tierPrice(base, tiers, qty) {
    let best = null;
    for (const t of tiers ?? [])
        if (dec(qty).greaterThanOrEqualTo(t.minQty) && (!best || dec(t.minQty).greaterThan(best.minQty)))
            best = t;
    return dec(best ? best.unitPrice : base).toString();
}
//# sourceMappingURL=retail.js.map